import React from "react";

const ErrorFaceImage = () => {
  return (
    <img src={require("../assets/notVerified.png")} alt="error face"></img>
  );
};

export default ErrorFaceImage;
